<template>
  <el-select v-model="branch" :disabled="disabled" clearable placeholder="Seleccione Bodega" size="medium"
    value-key="id" filterable @change="getDataBranchSelected">
    <el-option v-for="item in branches" :key="item.id" :label="item.razon_social" :value="item.id">
    </el-option>
  </el-select>
</template>

<script>
import { mapGetters } from "vuex";
import { getAll } from "@/api/store";
export default {
  props: ['default', 'disabled'],
  computed: {
    ...mapGetters(['document'])
  },
  created() {
    this.$emit('stop-loading', true)
    this.getBranches();
    if(this.disabled){
      this.branch = this.document.branch
    } 
  },
  data() {
    return {
      disabledBranch: false,
      branches: [],
      branch: '',
    }
  },
  watch: {
    default: function (val) {
      if (val)
      this.branch = val
    }
  },
  methods: {
    getBranches() {
      getAll()
        .then(({ data }) => {
          this.branches = data;
          this.$emit('stop-loading', false)
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getDataBranchSelected() {
      this.$emit('select', this.branch)
    },
    clear() {
      this.$emit('clear')
    },
    reset() {
      this.branch = ''
    }
  },
}
</script>